// extracted by mini-css-extract-plugin
export default {"item":"_51f9a56a","iconsWrapper":"_84d214","icon":"_1ae179b4"};